import vueComponentOptions from 'components/InputInteger.vue';

const IntegerInput = Vue.extend(vueComponentOptions);

module.exports = IntegerInput;
